import React, {Fragment, useEffect, useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import {withStyles} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import {useForm} from "react-hook-form";
import {Grid, MenuItem} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import ButtonAtm from "../../../../../atomic/Button/Button";
import ColAtm from "../../../../../atomic/Col/Col";
import { ValidatorForm, TextValidator, SelectValidator} from 'react-material-ui-form-validator';
import {getProperty, isDefined} from "../../../../../../utils";
import InputAdornment from "@material-ui/core/InputAdornment";
import LabelAtm from "../../../../../atomic/Label/Label";
import esLocale from "date-fns/locale/es";
import deLocale from "date-fns/locale/de";
import trLocale from "date-fns/locale/tr";
import ruLocale from "date-fns/locale/ru";
import moment from "moment";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TodayIcon from "@material-ui/icons/Today";
import { getAppLang } from '../../../../../../utils';
import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";
import {DialogContentText, DialogActions ,Button} from '@material-ui/core';
import { NETWORK_CHANNEL_PRICING_CHILD_DELETE } from '../../../../../../constants/api.constants';
import axios from 'axios';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export default function UpdateChildPaxModal(props) {
    const { t } = useTranslation();
    const default_currency = Object.keys(props.channelInformationData).length > 0 && props.channelInformationData.default_currency ? props.channelInformationData.default_currency : '';
    const currency = Object.keys(props.channelInformationData).length > 0 && props.channelInformationData.currency ? props.channelInformationData.currency : default_currency ;

    const [name, setName] = useState(props.child.name);
    const [type, setType] = useState((props.child.type === "FIX" && props.child.value === 0) ? "FREE" : props.child.type);
    const [val, setVal] = useState(props.child.value);
    const [adult, setAdult] = useState(props.child.adult);
    const [childOrder, setChildOrder] = useState(props.child.child_order);
    const [ageStart, setAgeStart] = useState(props.child.child_age_start);
    const [ageEnd, setAgeEnd] = useState(props.child.child_age_end);
    const [open, setOpen] = React.useState(false);
    const [rateMappingId] = React.useState(props.rateMappingId);
    const [isDateRange, setIsDateRange] = useState(props.child.reservation_start_date && props.child.reservation_end_date !== null ? true : false);
    const [startDate, setStartDate] = useState(props.child.reservation_start_date);
    const [endDate, setEndDate] = useState(props.child.reservation_end_date);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const localeMap = {
        es: esLocale,
        de: deLocale,
        tr: trLocale,
        ru: ruLocale
    };

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        props.clearErrorMessage();

        setName(props.child.name)
        setVal(props.child.value)
        setAdult(props.child.adult)
        setChildOrder(props.child.child_order)
        setAgeStart(props.child.child_age_start)
        setAgeEnd(props.child.child_age_end)
        setType((props.child.type === "FIX" && props.child.value === 0) ? "FREE" : props.child.type)
        setIsDateRange(props.child.reservation_start_date && props.child.reservation_end_date !== null ? true : false)
        setStartDate(props.child.reservation_start_date)
        setEndDate(props.child.reservation_end_date)
    };

    const changeVal = ({target}) => {
        const validated = (target.value).match(/^(\d*\.{0,1}\d{0,2}$)/)
        if (validated) {
            setVal(target.value)
        }
    }
    const handleChangeType = ({target}) => {
        setType(target.value);
    };
    const handleChangeAdult = ({target}) => {
        setAdult(target.value);
    };
    const handleChangeChildOrder = ({target}) => {
        setChildOrder(target.value);
    };
    const handleChangeAgeStart = ({target}) => {
        setAgeStart(target.value);
    };
    const handleChangeAgeEnd = ({target}) => {
        setAgeEnd(target.value);
    };

    const { handleSubmit } = useForm();
    const onSubmit = (data, e) => {
        e.preventDefault();

        const params = {
            property_id: getProperty(),
            name: name,
            adult: adult,
            pricing_policy_id: props.child.id,
            child_order: childOrder,
            child_age_start: ageStart,
            child_age_end: ageEnd,
            type: type === "FREE" ? "FIX" : type,
            value: type === "FREE" ? 0 : val,
            room_rate_channel_mapping_id : rateMappingId,
            reservation_start_date: !isDateRange ? null : startDate,
            reservation_end_date: !isDateRange ? null : endDate
        };
        props.updateChannelChildPricing(params)
    };

    useEffect( () => {


        if (props.updateChildPricingStatus === 200) {
            if(open){
                props.getChannelPaxList({ channel_id : props.channelInformationData.id } );
            }
            handleClose();
        }

    },[props.updateChildPricingStatus, props.errorUpdateChild] )

    const changeStartDate = date => {
        setStartDate(moment(date).format("YYYY-MM-DD"))
    }
    
    const changeEndDate = date => {
        setEndDate(moment(date).format("YYYY-MM-DD"))
    }

    const handleDeleteOpen = (e) => {
        setOpenDeleteModal(true);
    };

    const handleDeletePax = () => {

          const params = {
              params: {
                  property_id: getProperty(),
                  pricing_policy_id: props.child.id
              }
          }
          axios.post(NETWORK_CHANNEL_PRICING_CHILD_DELETE, params, {
              headers: {
                  "Accept": "application/json",
                  authToken: localStorage.getItem('auth'),
                  "Content-Type": "application/json",
                  "language": getAppLang(),
              }
          }).then((result) => {
                props.getChannelPaxList({ channel_id : props.channelInformationData.id } );
                // setOpen(false);
                // setOpenDeleteModal(false);
          }).catch(function (error) {
              console.log(error);
          });
      }
      const handleDeleteClose = () => {
        setOpenDeleteModal(false);
      }

    return (
        <>
            <ButtonAtm className="edit-channel-price-btn"
                       endIcon={<i className="fas fa-edit" />}
                       onClick={handleClickOpen}
                       title={t('btn-update')}
            />
            {
                openDeleteModal &&
                <div>
                    <Dialog
                        open={openDeleteModal}
                        onClose={handleDeleteClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle className="red-bottom-border" id="my-web-dialog">
                        {t('enw-web_alert-title')}
                        <IconButton aria-label="close" className='closeIcon' onClick={handleDeleteClose}>
                            <CloseIcon className="close-button" />
                        </IconButton>
                        </DialogTitle>
                        <DialogContent>
                        <DialogContentText className="register-text color-black" id="alert-dialog-slide-description">
                            {t('enw-web_alert-msg')}
                        </DialogContentText>
                        <DialogActions className='pb-0 m-auto'>
                            <Button onClick={handleDeleteClose} autoFocus className="room-rate-modal-save bg-dark-grey">{t('enw-input-checkbox-no')}</Button>
                            <Button onClick={handleDeletePax} className="room-rate-modal-save bg-red">{t('enw-input-checkbox-yes')}</Button>
                        </DialogActions>
                        </DialogContent>
                    </Dialog>
                </div>
            }
            <Dialog
                open={open}
                onClose={handleClose}
                disableBackdropClick={true}
                aria-labelledby="responsive-dialog-title"
                key={3}
            >
                <DialogTitle id="customized-dialog-title" className="red-bottom-border" onClose={handleClose}>
                    { t('enw-channels-channel_setup-child_pricing-title') }
                </DialogTitle>
                <DialogContent>
                    <Fragment>
                        <ValidatorForm onSubmit={handleSubmit(onSubmit)}>
                            {/* {props.updateChildPricingStatus === 200 && <Alert severity="success">{ t('enw-redirect_to_save-message') }</Alert>}*/}
                            {isDefined(props.errorUpdateChild) && <Alert severity="error">{props.errorUpdateChild.response.data.message}</Alert>}
                            <Grid container spacing={3} className="mb-20 pos-relative mobile-no-spacing">
                                {/*<Grid item xs={12} sm={4}>
                                        <TextValidator
                                            label={ t('enw-input-room_name') }
                                            type="text"
                                            fullWidth
                                            name="name"
                                            autoComplete="off"
                                            variant="outlined"
                                            value={name} onChange={changeName}
                                            validators={['required']}
                                            errorMessages={[ t("enw-notification_this_is_required") ]}
                                        />
                                    </Grid>*/}
                                <Grid item xs={12} sm={4}>
                                    <SelectValidator
                                        name="adult"
                                        onChange={handleChangeAdult}
                                        value={adult}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-channels-pricing-number_of_adults') }
                                        validators={['required']}
                                        errorMessages={[ t("enw-notification_this_is_required") ]}
                                    >
                                        {[...Array(11)].map((x, i) =>
                                            <MenuItem value={i} key={i}>
                                                {i}
                                            </MenuItem>
                                        )}
                                    </SelectValidator>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <SelectValidator
                                        name="childOrder"
                                        onChange={handleChangeChildOrder}
                                        value={childOrder}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-channels-pricing-which_child') }
                                        validators={['required']}
                                        errorMessages={[ t("enw-notification_this_is_required") ]}
                                    >
                                        {[...Array(10)].map((x, i) =>
                                            <MenuItem value={i+1} key={i}>
                                                {i+1}.
                                            </MenuItem>
                                        )}
                                    </SelectValidator>
                                </Grid>
                                <Grid item xs={6} sm={2} className="m-child-age-policy-first">
                                    <TextValidator
                                        label={ t('enw-channels-pricing-age_range') }
                                        name="ageStart"
                                        fullWidth
                                        autoComplete="off"
                                        value={ageStart} onChange={handleChangeAgeStart}
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        validators={['required','minNumber:0', `maxNumber:${ isDefined(ageEnd) ? ageEnd : 18}`]}
                                        errorMessages={[ t("enw-notification_this_is_required"),`minNumber:0`, `maxNumber:${ isDefined(ageEnd) ? ageEnd : 18}`]}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={2} className="m-child-age-policy-second">
                                    <TextValidator
                                        label={ t('enw-channels-pricing-age_range') }
                                        name="ageEnd"
                                        fullWidth
                                        autoComplete="off"
                                        value={ageEnd} onChange={handleChangeAgeEnd}
                                        variant="outlined"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        validators={['required', `minNumber:${isDefined(ageStart) ? ageStart : 0}`, 'maxNumber:18',]}
                                        errorMessages={[ t("enw-notification_this_is_required"),`minNumber:${isDefined(ageStart) ? ageStart : 0}`, 'maxNumber 18']}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <SelectValidator
                                        name="type"
                                        onChange={handleChangeType}
                                        value={type}
                                        className="form-control"
                                        variant="outlined"
                                        fullWidth
                                        label={ t('enw-input-value_type') }
                                        validators={['required']}
                                        errorMessages={[ t("enw-notification_this_is_required") ]}
                                    >
                                        <MenuItem value={"FREE"}>
                                            { t('enw-input-free') }
                                        </MenuItem>
                                        <MenuItem value={"PER"}>
                                            { t('enw-input-percent') }
                                        </MenuItem>
                                        <MenuItem value={"FIX"}>
                                            { t('enw-input-fixed') }
                                        </MenuItem>
                                    </SelectValidator>
                                </Grid>
                                {
                                    type !== "FREE" &&
                                    <Grid item xs={12} sm={4}>
                                        <TextValidator
                                            label={ t('enw-input-value') }
                                            name="value"
                                            fullWidth
                                            autoComplete="off"
                                            value={val}
                                            onChange={changeVal}
                                            variant="outlined"
                                            validators={['required']}
                                            errorMessages={[ t("enw-notification_this_is_required") ]}
                                            InputProps={{
                                                endAdornment: <>
                                                    {
                                                        type === "PER" ?
                                                            <InputAdornment position="start">
                                                                %
                                                            </InputAdornment>
                                                            :
                                                            type === "FIX" ?
                                                                <InputAdornment position="start">
                                                                    {currency}
                                                                </InputAdornment>
                                                                :
                                                                <InputAdornment position="start">

                                                                </InputAdornment>
                                                    }
                                                </>
                                            }}
                                        />
                                    </Grid>
                                }
                                <Grid item xs={12} className='pax-grid'>
                                            <ColAtm>
                                                <LabelAtm variant="h6" component="h3" text={ t('enw-channels-channel_setup-rate_date-range-title') } />
                                            </ColAtm>
                                        </Grid>
                                        <Grid item className='pax-radio'>
                                            <input type={"radio"} name={"dateRange"}
                                                id={"dateRange2"}
                                                value={"false"}
                                                className="d-none"
                                                   checked={ !isDateRange }
                                                   onClick={(e) => { setIsDateRange(false) }}
                                            />
                                            <label className="show-channel-detail"
                                                htmlFor={"dateRange2"}>
                                                { t('btn-not_affected') }
                                            </label>
                                        </Grid>
                                        <Grid item className='pax-radio'>
                                            <input type={"radio"} name={"dateRange"}
                                                id={"dateRange"}
                                                value={"true"}
                                                className="d-none"
                                                   checked={ isDateRange }
                                                   onClick={(e) => { setIsDateRange(true) }}
                                            />
                                            <label className="show-channel-detail" htmlFor={"dateRange"}>
                                                { t('btn-affected') }
                                            </label>

                                        </Grid>

                                        {
                                    isDateRange ? (
                                        <Grid container justify="space-between" spacing={12} className="mobile-no-spacing mb-12">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[getAppLang()]}>
                                                <Grid item xs={12} md={6} style={{padding: "12px", paddingTop: "0px"}}>
                                                    <DatePicker
                                                        margin="normal"
                                                        label={ t('enw-input-from_date')}
                                                        className="w-100"
                                                        required={isDateRange ? true : false}
                                                        variant="inline"
                                                        autoOk
                                                        inputVariant="outlined"
                                                        format="dd.MM.yyyy"
                                                        value={startDate}
                                                        onChange={changeStartDate}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton>
                                                                        <TodayIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} style={{padding: "12px", paddingTop: "0px"}} >
                                                    <DatePicker
                                                        margin="normal"
                                                        label={ t('enw-input-to_date')}
                                                        variant="inline"
                                                        inputVariant="outlined"
                                                        className="w-100"
                                                        required={isDateRange ? true : false}
                                                        format="dd.MM.yyyy"
                                                        autoOk
                                                        value={endDate}
                                                        minDate={ moment(startDate).add(1,'days') }
                                                        onChange={changeEndDate}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton>
                                                                        <InsertInvitationIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    ) : (<></>)
                                }
                                        
                            </Grid>
                            <ColAtm className="mt-13" md={12}>
                                <ButtonAtm
                                    className="m-auto room-rate-modal-save bg-dark-grey"
                                    type="button"
                                    buttontext={ t('btn-delete') }
                                    color="primary"
                                    onClick={handleDeleteOpen}
                                />
                                <ButtonAtm
                                    className="m-auto room-rate-modal-save bg-red"
                                    type="submit"
                                    buttontext={ t('btn-save') }
                                    color="primary"
                                    // disabled={isDateRange && startDate !== null && endDate !== null ? false : !isDateRange ? false : true}
                                    disabled={isDateRange && (startDate === null || endDate === null) && true}
                                />
                            </ColAtm>
                        </ValidatorForm>
                    </Fragment>
                </DialogContent>
            </Dialog>
        </>
    );
}
